import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(dashboard)/analytics/overview/')({
  beforeLoad: () => {
    throw redirect({ to: '/analytics/statistics' })
  },
})
